import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components/UI';
import { MenuDivider, MenuDropdown, MenuGroup, MenuItemStyled } from './styles';

export interface IMoreFiltersActions {
  onPrintList?: () => void;
  onPrintDetails: () => void;
  onExportCsv?: () => void;
  onExportXml?: () => void;
  onResetFilters: () => void;
  onCancel: () => void;
  onImportBcf?: () => void;
  onExportBcf?: () => void;
}

const MoreFiltersActions: FC<IMoreFiltersActions> = ({
  onPrintDetails,
  onResetFilters,
  onCancel,
  onImportBcf,
  onExportBcf,
}) => {
  const { t } = useTranslation('activities');

  const handleAction = (action: () => void) => {
    action();
    onCancel();
  }

  const handleImportBcf = () => {
    onImportBcf?.();
    onCancel();
  }

  const handleExportBcf = () => {
    onExportBcf?.();
    onCancel();
  }

  return (
    <MenuDropdown>
      <MenuGroup>
        {/*
        <MenuItemStyled onClick={() => handleAction(onPrintList)}>
          <Icon
            icon="arquivo"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            {t('moreActions.printList')}
          </span>
        </MenuItemStyled>
        */}

        <MenuItemStyled onClick={() => handleAction(onPrintDetails)}>
          <Icon
            icon="docEye"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            {t('moreActions.printReport')}
          </span>
        </MenuItemStyled>
      </MenuGroup>

      {/* <MenuDivider /> */}

      {/* <MenuGroup>
        <MenuItemStyled onClick={() => handleAction(onExportCsv)}>
          <Icon
            icon="download"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            {t('moreActions.exportCsv')}
          </span>
        </MenuItemStyled>

        <MenuItemStyled onClick={() => handleAction(onExportXml)}>
          <Icon
            icon="download"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            {t('moreActions.exportXml')}
          </span>
        </MenuItemStyled>
      </MenuGroup> */}

      {(onExportBcf || onImportBcf) && (
        <>
          <MenuDivider />
          <MenuGroup>
            {onExportBcf && (
              <MenuItemStyled onClick={handleExportBcf}>
                <Icon
                  icon="download"
                  customSize={16}
                  className="clearFilters"
                />
                <span className="textItem">
                  {t('moreActions.exportBcf')}
                </span>
              </MenuItemStyled>
            )}
            {onImportBcf && (
              <MenuItemStyled onClick={handleImportBcf}>
                <Icon
                  icon="upload"
                  customSize={16}
                  className="clearFilters"
                />
                <span className="textItem">
                  {t('moreActions.importBcf')}
                </span>
              </MenuItemStyled>
            )}
          </MenuGroup>
        </>
      )}

      <MenuDivider />

      <MenuGroup>
        <MenuItemStyled onClick={() => handleAction(onResetFilters)}>
          <Icon
            icon="eraseFilter"
            customSize={16}
            className="clearFilters"
          />
          <span className="textItem">
            {t('moreActions.resetFilters')}
          </span>
        </MenuItemStyled>
      </MenuGroup>
    </MenuDropdown>
  );
};

export default MoreFiltersActions;
